var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 496H16V16H176V496Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336 496H176V16H336V496Z",
    fill: "#C0392B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496H336V16H496V496Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.775 276.906L278.533 276.907C278.558 279.461 280.055 282.205 282.157 283.777H269.207C271.233 281.94 271.787 279.763 271.775 276.906L271.775 276.906Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.07 238.634L232.77 242.711L278.827 242.787L282.603 238.71L270.825 238.559L265.086 234.557L246.587 234.481L241.226 238.634H229.07L229.07 238.634Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.927 233.95L263.831 233.934C265.984 232.795 266.655 229.16 266.645 227.126C266.615 221.117 262.412 218.234 258.194 218.081C257.562 218.05 256.828 217.558 256.661 216.982C256.245 215.677 256.353 214.845 255.897 214.891C255.493 214.886 255.611 215.652 255.251 216.875C255.053 217.484 254.369 218.084 253.686 218.119C248.436 218.381 245.05 222.214 245.182 227.126C245.271 230.374 245.649 232.314 247.926 233.951L247.927 233.95Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.749 290.651H290.081L283.964 285.667H227.865L221.749 290.651H221.749Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.08 271.931L254.325 275.668H257.156L254.892 271.93L253.08 271.931L253.08 271.931ZM251.495 275.668L252.212 279.367L255.533 279.405L254.325 275.667L251.495 275.668L251.495 275.668ZM257.119 275.706L259.422 279.367H264.141L260.442 275.667L257.119 275.706H257.119ZM229.258 284.087C231.762 281.758 233.36 279.771 233.373 276.914H239.488C239.501 278.512 240.08 279.468 240.961 279.405L247.153 279.368L247.115 275.706H242.622L242.621 255.734C242.458 248.675 251.204 244.56 254.778 244.597L233.523 244.56V243.918H278.222L278.26 244.56L256.703 244.597C263.096 244.61 269.262 250.664 269.313 255.773V261.435H268.482L268.444 255.849C268.444 250.261 261.406 245.038 255.759 245.202C250.875 245.342 243.301 249.997 243.376 255.811V257.548L254.966 257.623L254.853 259.624L256.672 260.785L260.302 261.942L260.249 264.943L262.849 265.709L262.871 268.707L265.99 270.045V273.149L267.968 274.367L267.877 277.519L270.558 279.406H264.215L268.18 283.823H262.328L259.42 279.406H255.57L257.307 283.785L253.193 283.747L252.21 279.406H247.189L247.227 284.086L229.257 284.087L229.258 284.087ZM247.191 271.967V275.667H251.495L250.625 271.967H247.191Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.097 265.436H247.417V271.589H250.097V265.436Z",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.631 272.02H246.247L246.231 267.492C246.197 265.524 247.963 263.54 248.809 263.474C249.746 263.439 251.128 265.332 251.175 267.338L251.212 272.035L253.988 272.029V260.371L243.631 260.426V272.02L243.631 272.02Z",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M267.579 274.722H264.332V277.251H267.579V274.722Z",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.654 270.378H262.407V272.907H265.654V270.378Z",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M262.523 266.034H259.276V268.564H262.523V266.034Z",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M259.845 262.377H256.599V264.906H259.845V262.377Z",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.447 272.036L257.768 272.149L263.695 277.397V274.301L261.695 272.867V270.412L258.788 268.752V266.109L255.956 265.166V261.579L254.521 260.408L254.447 272.036V272.036Z",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M269.275 264.376H268.482V270.077H269.275V264.376Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.474 245.106C220.475 243.503 219.28 247.33 215.174 250.179C213.262 251.48 211.93 254.946 211.918 257.227C211.855 258.794 212.092 260.356 211.917 261.872C211.807 262.83 210.808 264.958 211.491 265.502C213.298 266.846 215.638 269.896 216.723 270.948C217.661 271.77 218.474 266.703 219.178 264.435C219.933 262.004 219.595 259.099 221.688 256.853C223.172 255.337 226.914 253.845 226.493 253.169L221.474 245.106H221.474Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.263 257.524C220.952 256.807 220.489 256.066 219.923 255.425C219.358 254.785 218.69 254.247 217.952 253.984C217.238 253.722 216.512 253.377 216.005 252.746C215.752 252.43 215.533 252.032 215.424 251.558C215.323 251.118 215.324 250.578 215.398 249.965C215.31 250.029 215.263 250.103 215.171 250.167C213.259 251.468 211.922 254.939 211.91 257.22C211.885 257.85 211.884 258.465 211.91 259.091C212.051 259.484 212.188 259.864 212.39 260.102C212.654 260.412 212.967 260.617 213.3 260.759C213.966 261.045 214.736 261.103 215.449 261.366C216.187 261.629 216.947 262.222 217.598 262.934C218.218 263.612 218.696 264.39 219.013 265.082C219.067 264.886 219.138 264.594 219.19 264.425C219.874 262.224 219.754 259.661 221.263 257.524H221.263Z",
    fill: "#BF0000",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M215.406 249.847C215.015 252.561 216.527 253.465 217.953 253.991C219.43 254.515 220.64 256.099 221.264 257.533",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M211.75 258.786C212.373 261.127 214.013 260.834 215.44 261.36C216.916 261.884 218.469 263.752 219.093 265.185",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.09 243.448L220.838 242.968L235.199 267.154L234.452 267.634L220.09 243.448H220.09Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.635 242.485C221.635 242.924 221.461 243.345 221.151 243.655C220.84 243.966 220.419 244.14 219.98 244.14C219.541 244.14 219.12 243.966 218.81 243.655C218.5 243.345 218.325 242.924 218.325 242.485C218.325 242.046 218.5 241.625 218.81 241.315C219.12 241.004 219.541 240.83 219.98 240.83C220.419 240.83 220.84 241.004 221.151 241.315C221.461 241.625 221.635 242.046 221.635 242.485V242.485Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M239.735 223.055H233.915V224.389H239.735V223.055Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M239.735 225.586H233.915V236.737H239.735V225.586Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.559 221.533L240.015 221.571C240.267 219.382 238.082 217.017 236.806 217.041C235.545 217.102 233.509 219.432 233.559 221.533H233.559Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.03 220.215C248.799 220.733 247.856 222.138 247.274 223.754C246.693 225.37 246.472 227.206 246.743 228.684V228.709C246.847 229.219 246.987 229.585 247.148 229.847C247.309 230.108 247.49 230.262 247.704 230.302C247.919 230.341 248.12 230.226 248.235 230.049C248.35 229.871 248.407 229.637 248.387 229.366C248.27 227.846 248.277 226.347 248.639 224.993C249.001 223.639 249.722 222.433 251.041 221.454C251.28 221.279 251.417 221.079 251.446 220.872C251.475 220.665 251.365 220.489 251.218 220.367C250.924 220.122 250.46 220.037 250.03 220.215H250.03ZM250.156 220.569C250.456 220.445 250.838 220.518 250.99 220.645C251.067 220.708 251.076 220.752 251.066 220.822C251.056 220.891 251.004 221.011 250.813 221.15C249.428 222.179 248.665 223.473 248.285 224.892C247.906 226.31 247.914 227.853 248.033 229.392C248.048 229.6 247.988 229.76 247.931 229.847C247.875 229.934 247.845 229.96 247.78 229.948C247.715 229.936 247.58 229.853 247.451 229.644C247.323 229.436 247.195 229.113 247.097 228.633C246.843 227.246 247.067 225.44 247.628 223.88C248.189 222.321 249.087 221.019 250.156 220.569L250.156 220.569Z",
    fill: "#BD6B00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.109 221.808C250.88 222.325 250.085 223.662 249.657 225.196C249.228 226.729 249.161 228.484 249.429 229.948C249.64 230.987 250.185 231.535 250.719 231.617C250.985 231.658 251.243 231.552 251.401 231.339C251.56 231.125 251.611 230.838 251.527 230.479C251.226 229.267 251.11 227.756 251.325 226.384C251.54 225.011 252.086 223.786 253.12 223.047C253.359 222.873 253.495 222.672 253.525 222.465C253.554 222.259 253.444 222.057 253.297 221.934C253.003 221.69 252.539 221.63 252.109 221.808H252.109ZM252.261 222.162C252.56 222.038 252.916 222.11 253.069 222.238C253.146 222.302 253.18 222.346 253.171 222.415C253.161 222.484 253.083 222.605 252.893 222.743C251.751 223.559 251.171 224.899 250.946 226.333C250.721 227.768 250.861 229.298 251.174 230.555C251.24 230.841 251.174 231.033 251.098 231.136C251.021 231.239 250.924 231.287 250.769 231.263C250.459 231.215 249.974 230.814 249.783 229.872C249.526 228.472 249.599 226.743 250.011 225.271C250.422 223.8 251.189 222.612 252.261 222.162V222.162Z",
    fill: "#BD6B00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M240.093 245.802H233.6V254.787H240.093V245.802Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M240.247 259.927H233.98V261.814H240.247V259.927Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M240.244 263.243H233.826V270.265H240.244V263.243Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M240.395 271.705H233.373V275.631H240.395V271.705Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.239 258.236H239.897L241.019 256.368H233.224L234.239 258.236H234.239Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.867 251.352L241.921 246.44H245.818C244.287 247.704 242.864 249.234 241.867 251.352Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.611 253.366C234.65 254.417 235.839 253.948 235.839 253.419C235.839 251.799 235.861 250.047 235.796 248.899C235.788 248.054 237.811 248.266 237.799 248.786C237.807 250.155 237.822 252.032 237.83 253.633C237.816 254.413 239.137 254.345 239.118 253.633C239.11 251.844 239.11 249.245 239.118 247.928C239.13 246.233 234.668 246.27 234.633 247.891C234.635 249.221 234.609 251.604 234.611 253.366L234.611 253.366Z",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M239.225 264.076H234.619V269.815H239.225V264.076Z",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M239.187 266.455H237.564V267.399H239.187V266.455Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M236.318 266.455H234.732V267.399H236.318V266.455Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M237.564 264.149H236.318V266.49H237.564V264.149Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M237.564 267.361H236.318V269.853H237.564V267.361Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.69 206.633C210.978 211.136 209.581 213.608 207.196 213.232C206.538 210.734 208.033 209.058 210.69 206.633Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.456 216.615C203.336 215.536 204.866 207.301 205.679 203.85C206.281 208.296 207.289 214.616 205.456 216.615Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.209 217.003C209.773 218.243 212.595 214.404 213.548 209.959C210.607 214.019 205.819 214.024 206.209 217.003Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.507 221.161C200.72 220.425 202.398 211.688 202.905 208.193C203.517 211.803 205.439 219.965 203.507 221.161Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.461 220.886C204.617 217.873 207.62 218.744 209.693 217.136C209.355 218.641 208.08 221.31 204.461 220.886Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.047 224.923C198.286 224.178 199.946 214.775 199.789 210.904C200.599 214.249 203.163 224.017 201.047 224.923Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.334 224.519C204.596 225.254 207.593 223.784 207.829 221.09C205.88 222.412 202.769 221.401 202.334 224.519Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.985 229.073C196.343 229.284 197.525 221.276 197.527 213.818C198.498 220.789 201.141 227.17 198.985 229.073Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.899 228.709C201.683 229.604 204.879 228.173 205.791 225.16C202.568 226.561 200.413 225.192 199.899 228.709Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.632 210.807C220.163 214.713 218.566 216.986 216.181 216.61C215.524 214.112 217.458 212.515 220.632 210.807Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.322 220.83C218.285 221.392 219.712 218.351 222.379 214.463C218.641 217.168 214.172 217.73 214.322 220.83Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.198 220.385C211.038 217.793 213.125 214.538 214.776 211.764C214.421 215.891 215.828 218.187 213.198 220.385Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.243 224.665C212 222.13 216.319 221.566 218.272 220.157C217.615 221.622 216.619 225.566 212.243 224.665Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.337 224.72C208.351 224.382 209.591 219.311 211.732 216.493C210.83 220.382 213.309 223.086 211.337 224.72Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.088 228.943C205.69 227.441 207.868 223.178 209.145 220.661C208.6 223.966 211.324 226.483 209.088 228.943Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.76 228.547C211.544 230.876 215.019 227.853 215.732 224.321C212.708 226.839 210.474 226.425 209.76 228.547Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.994 244.936C201.645 241.468 204.253 235.161 202.402 231.799C202.149 231.337 202.956 230.111 203.477 230.855C204.291 232.042 205.128 235.427 205.478 234.177C205.849 232.818 205.906 230.415 207.109 229.948C207.877 229.675 208.962 229.496 208.666 230.704C208.372 231.865 207.714 233.47 208.444 233.573C208.867 233.636 210.086 231.992 211.113 231.233C211.94 230.555 213.175 231.615 211.965 232.629C208.033 235.895 204.223 237.364 201.994 244.936L201.994 244.936Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.932 297.138C194.47 297.05 193.838 296.893 194.413 297.611C199.007 303.27 200.337 304.83 207.035 304.034C213.802 303.143 215.414 301.313 220.152 298.654C222.683 297.169 226.383 296.84 229.188 297.759C230.494 298.187 231.284 298.213 230.348 297.275C229.411 296.34 228.305 295.066 227.154 294.189C224.631 292.252 220.353 291.413 216.861 292.036C211.923 292.81 207.843 295.955 202.967 297.142C200.405 297.727 197.594 297.639 194.932 297.138L194.932 297.138Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.592 307.251C234.446 307.357 234.987 309.012 235.408 307.892C236.121 306.078 235.621 304.635 234.82 304.794C233.874 305.047 232.274 307.168 233.592 307.251L233.592 307.251Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.769 242.186C190.786 241.159 191.07 240.767 192.523 240.751C193.676 240.678 195.961 241.457 196.828 240.826C197.622 240.249 197.306 237.802 197.659 236.673C197.813 236.044 198.253 235.057 199.244 236.598C202.174 241.294 205.834 246.931 207.398 252.454C208.253 255.549 207.448 260.381 204.604 263.629C204.705 260.86 203.673 258.998 202.414 256.682C200.86 253.639 195.088 245.396 191.769 242.186L191.769 242.186Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.846 266.876C207.068 266.891 207.622 262.572 207.622 261.364C206.036 261.666 203.242 264.309 203.846 266.876Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.691 308.795C233.982 309.317 233.951 303.798 231.61 301.458C232.641 305.003 229.888 308.244 231.691 308.795Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.801 308.748C230.952 311.371 224.363 308.405 222.669 306.364C226.562 308.018 230.609 306.649 230.801 308.748Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.913 305.002C228.149 307.543 222.199 305.309 220.44 303.324C224.347 304.586 227.653 302.911 227.913 305.002Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.005 305.358C231.296 305.879 230.925 300.171 228.698 298.209C229.767 302.018 227.203 304.806 229.005 305.358Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.594 301.888C228.886 302.409 227.571 297.494 225.872 295.531C226.148 299.115 225.019 301.6 226.594 301.888Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.381 301.871C225.617 304.488 220.988 302.479 219.192 300.003C223.061 301.266 225.121 299.78 225.381 301.871Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.119 299.881C225.62 298.802 224.028 295.947 221.17 296.124C221.45 297.848 222.437 300.881 224.119 299.881Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.404 311.716C235.555 314.339 228.965 313.034 226.894 310.239C231.051 311.025 235.211 309.618 235.404 311.716Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.226 307.025C209.462 309.641 202.267 306.764 200.471 304.288C204.34 305.551 208.966 304.933 209.226 307.025Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.635 308.14C215.136 307.061 212.071 304.281 209.63 303.628C209.909 305.352 211.953 309.14 213.635 308.14Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.096 309.952C214.257 312.305 206.381 311.015 204.32 308.841C211.097 310.066 213.874 307.937 214.096 309.952Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.785 311.522C218.659 313.707 211.099 313.174 208.445 311.903C212.734 311.866 217.184 309.999 217.785 311.522Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.32 313.115C222.157 315.074 215.163 315.032 211.755 313.949C216.27 313.912 220.492 311.178 221.32 313.115Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.408 314.167C227.647 316.484 220.27 316.71 217.876 315.569C222.141 314.982 225.353 312.343 226.408 314.167Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.769 310.203C215.422 311.683 215.547 307.32 213.681 304.298C216.614 306.969 219.359 308.792 217.769 310.203Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.927 311.772C219.958 313.516 218.384 307.529 216.592 304.169C219.489 307.367 223.743 310.324 221.927 311.772Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.427 313.439C225.76 315.371 220.94 307.761 219.187 303.797C221.856 306.883 228.753 311.802 227.427 313.439Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.736 319.248C221.904 322.186 209.637 316.478 208.267 313.521C215.287 317.241 222.903 316.463 222.736 319.248Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.315 259.547C183.028 259.175 182.204 259.557 182.409 260.453C182.601 261.667 184.391 267.899 187.467 270.042C189.66 271.623 201.191 274.169 206.418 275.251C209.295 275.83 211.704 277.265 213.592 279.555C212.811 276.56 212.184 274.341 211.176 271.628C210.196 269.243 207.599 266.633 204.909 266.493C199.914 266.313 193.449 265.888 188.751 263.85C186.327 262.837 184.875 261.469 183.315 259.547L183.315 259.547Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.944 284.212C213.519 285.372 215.257 281.216 213.257 277.265C213.194 281.068 210.171 282.344 211.944 284.212Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.457 288.021C215.635 288.69 216.317 284.836 214.883 281.754C215.122 285.066 211.458 287.06 213.457 288.021Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.115 291.08C217.219 292.127 218.015 288.234 216.503 285.343C216.668 289.031 213.494 290.118 215.115 291.08Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.25 291.314C213.416 293.806 208.581 289.166 207.766 286.643C210.767 289.624 214.85 289.294 214.25 291.314Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.057 287.504C211.11 289.996 205.03 283.581 203.686 280.492C206.687 283.473 212.734 285.748 212.057 287.504Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.852 283.767C209.905 286.598 203.296 279.052 201.424 276.377C204.577 279.321 211.566 281.71 210.852 283.767Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.642 280.967C212.969 280.515 210.51 278.577 207.657 275.427C207.524 278.743 208.068 281.062 210.642 280.967Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.718 279.082C207.723 277.988 205.755 277.522 203.318 274.787C202.959 276.631 205.579 280.008 206.718 279.082Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.979 291.379C219.252 292.124 220.124 289.515 218.537 287.152C218.174 289.708 216.811 290.418 217.979 291.379Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.321 274.917C187.617 276.538 183.322 270.069 182.176 267.408C184.549 270.462 190.831 273.252 190.321 274.917Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.618 278.686C191.122 280.345 186.412 275.84 184.776 273.557C187.3 275.743 193.28 276.003 192.618 278.686Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.182 282.068C194.689 284.333 187.816 279.24 186.209 276.829C189.172 279.621 195.633 279.369 195.182 282.068V282.068Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.131 284.519C193.071 286.559 187.481 281.504 186.139 278.867C189.554 281.848 194.996 282.502 194.131 284.519Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.259 274.585C193.023 272.725 192.271 271.854 190.986 268.923C190.283 271.933 189.223 273.134 191.259 274.585Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.597 278.095C196.796 278.236 193.628 274.344 192.871 271.074C193.149 274.8 192.051 277.738 193.597 278.095Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.635 281.186C197.852 280.685 197.213 277.548 195.514 273.749C195.867 277.854 193.637 280.225 195.635 281.186Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.883 287.391C194.05 289.882 187.743 284.11 186.739 281.926C189.929 284.605 195.446 285.522 194.883 287.391Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.661 291.282C197.715 293.775 191.106 288.72 189.084 285.969C193.066 289.101 199.15 288.81 198.661 291.282Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.512 295.206C201.452 298.679 194.541 293.134 192.481 290.421C196.879 293.779 203.075 292.734 202.512 295.206V295.206Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.016 286.282C197.893 287.254 198.651 281.927 197.592 278.166C197.606 282.27 193.828 285.321 196.016 286.282Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.219 290.514C201.474 291.183 200.759 285.442 198.832 281.718C198.583 285.407 196.918 288.911 199.219 290.514Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.224 294.477C205.743 294.618 204.009 289.555 201.931 286.7C202.285 290.427 201.112 294.045 203.224 294.477Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.807 296.638C198.049 297.921 196.197 295.547 193.155 293.815C195.891 294.531 199.143 295.448 198.807 296.638Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.367 253.973C199.718 252.233 197.924 248.979 197.367 245.885C196.61 248.82 194.618 252.671 197.367 253.973Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.286 258.309C193.753 257.884 194.285 253.316 194.179 250.421C195.241 254.351 198.136 255.015 197.286 258.309Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.844 257.718C200.832 257.545 200.674 254.145 200.833 250.706C199.319 253.867 197.525 254.358 197.844 257.718Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.723 261.941C195.398 262.126 194.19 259.843 193.659 256.283C195.863 259.563 197.868 258.541 197.723 261.941Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.556 261.657C201.544 262.042 201.066 258.563 200.947 255.999C200.031 258.443 197.6 259.213 198.556 261.657Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.896 260.186C194.135 262.457 195.57 266.361 197.881 265.484C198.837 262.695 195.848 262.138 193.896 260.186Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.596 265.727C197.56 263.735 200.947 262.737 201.664 260.148C202.075 263.854 201.73 266.284 198.596 265.727Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.962 242.121C190.822 240.118 189.179 236.939 188.621 233.845C187.865 236.78 186.553 240.669 188.962 242.121Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.905 245.851C185.638 246.182 184.847 239.537 184.515 236.68C185.577 240.61 189.34 242.407 188.905 245.851Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.576 245.786C191.885 244.593 191.349 242.025 192.074 240.095C190.522 242.463 189.107 242.803 189.576 245.786Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.929 250.139C185.511 250.431 183.475 243.069 183.369 240.174C184.431 244.104 189.327 246.241 188.929 250.139Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.584 250.025C192.799 249.286 192.414 247.207 191.932 243.843C190.908 247.231 189.115 246.513 189.584 250.025Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.889 254.386C185.13 255.023 185.394 249.078 182.41 244.765C184.991 247.968 189.639 252.005 188.889 254.386Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.738 254.183C192.575 254.265 192.853 249.994 192.695 248.261C192.043 249.987 188.707 251.626 189.738 254.183Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.016 249.807C184.425 254.381 186.426 258.964 188.888 258.616C190.07 256.016 186.553 255.684 183.016 249.807V249.807Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.779 257.944C188.743 255.953 192.129 254.955 192.846 252.366C193.258 256.071 192.913 258.502 189.779 257.944Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.986 255.032C185.998 259.153 186.906 263.889 189.669 263.2C190.7 259.996 186.618 259.325 183.986 255.032V255.032Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.24 262.418C189.053 260.238 192.439 259.466 193.269 256.462C193.719 260.394 193.298 263.202 190.24 262.418Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.032 234.525C198.015 235.062 200.095 232.835 199.374 229.503C197.107 230.067 196.068 232.125 196.032 234.525Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.69 232.858C189.863 233.796 191.003 233.881 190.671 232.557C190.395 231.482 190.348 230.674 190.671 229.801C191.115 228.706 190.967 226.842 190.634 226.064C190.297 225.242 189.183 225.723 189.652 226.366C190.168 227.111 190.195 228.661 189.84 229.385C189.374 230.454 189.5 231.873 189.69 232.858H189.69Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.191 245.737C207.424 246.864 205.86 246.175 207.052 244.627C208.028 243.374 209.42 242.351 209.523 241.057C209.604 239.415 210.567 236.925 211.443 236.086C212.347 235.191 213.391 236.45 212.425 237.046C211.339 237.752 210.633 240.652 210.657 241.767C210.62 243.386 209.006 244.556 208.191 245.737V245.737Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.78 243.925C205.014 245.052 203.793 244.398 204.484 242.588C205.069 241.336 205.131 239.783 205.782 238.867C206.692 237.479 208.234 236.321 209.109 235.482C210.013 234.587 210.764 235.449 209.935 236.216C208.928 237.223 207.836 238.477 207.229 239.427C206.097 241.272 206.595 242.744 205.78 243.925L205.78 243.925Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.047 238.093C192.956 239.684 194.236 240.069 194.179 237.762C194.121 235.353 192.417 233.149 193.462 229.482C194.012 227.688 194.022 224.401 193.688 222.654C193.396 220.921 192.163 222.053 192.631 223.403C193.147 224.967 192.535 227.968 192.14 229.478C190.956 233.874 193.116 236.015 193.047 238.093L193.047 238.093Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.542 229.291C196.354 230.755 195.114 230.888 195.475 228.82C195.775 227.142 195.826 225.88 195.475 224.516C194.992 222.806 195.153 219.894 195.515 218.679C195.881 217.396 197.092 218.148 196.582 219.151C196.022 220.315 195.992 222.736 196.378 223.867C196.885 225.536 196.747 227.752 196.542 229.291L196.542 229.291Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.954 259.239C184.567 259.969 185.601 259.48 184.659 258.492C183.888 257.694 184.142 257.443 183.672 256.47C183.208 255.384 183.232 254.784 182.671 254.008C182.175 253.272 181.429 254.023 181.929 254.643C182.556 255.376 182.383 255.916 182.767 256.625C183.476 257.839 183.303 258.476 183.954 259.239L183.954 259.239Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.457 279.148C202.43 280.118 203.928 282.542 204.027 284.516C204.194 286.788 204.522 288.706 205.542 290.321C203.918 289.869 203.14 287.28 202.909 284.8C202.675 282.233 201.292 281.12 200.457 279.147V279.148Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.566 283.904C205.932 286.425 207.842 287.386 207.939 289.257C208.105 291.41 208.268 291.519 208.851 293.636C207.244 293.208 206.839 293.068 206.405 289.847C206.137 287.583 204.325 285.986 204.566 283.904H204.566Z",
    fill: "white",
    stroke: "#BD6B00",
    strokeWidth: 0.466923
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.077 307.227C247.844 308.673 248.726 310.876 250.323 310.473C250.348 309.365 248.599 308.598 247.077 307.227Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.455 307.72C252.558 308.991 255.237 308.677 255.571 310.628C252.66 310.942 251.596 309.746 249.455 307.72Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.464 297.454C238.553 299.166 239.909 301.12 240.541 303.645C241.2 305.997 242.127 307.873 243.486 309.987C241.271 308.477 239.879 306.422 239.182 303.946C238.57 301.513 237.848 299.694 236.464 297.454H236.464Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.036 297.446C241.276 299.234 243.388 301.264 244.02 303.789C244.679 306.141 245.077 307.941 246.588 310.282C244.222 308.772 243.282 306.49 242.586 304.014C241.974 301.582 240.572 299.763 239.036 297.446H239.036Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.43 303.302C246.368 302.861 246.671 302.475 247.034 302.359C247.741 302.094 248.446 301.879 249.147 301.68C249.945 301.491 250.391 302.061 250.394 302.435C250.398 303.057 250.427 303.586 250.394 304.057C250.351 304.645 250.239 304.688 249.865 304.775C249.268 304.876 248.503 304.978 247.903 305.379C247.427 305.671 246.97 305.44 246.732 304.927C246.579 304.535 246.495 303.767 246.43 303.302L246.43 303.302Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.029 303.303C255.084 302.861 254.851 302.438 254.527 302.322C253.895 302.057 253.265 301.992 252.601 302.019C251.864 302.008 251.678 302.174 251.676 302.548C251.673 303.17 251.646 303.774 251.676 304.246C251.715 304.834 251.702 304.877 252.035 304.964C252.569 305.065 253.479 305.092 254.015 305.493C254.439 305.785 254.924 305.554 254.947 305.003C254.937 304.587 254.971 303.768 255.029 303.303L255.029 303.303Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.088 326.099C279.125 327.055 279.239 327.823 279.806 328.591C276.508 327.27 271.853 327.977 268.669 329.46C267.248 330.138 265.53 328.685 267.196 327.307C269.565 325.387 275.048 326.476 279.088 326.099V326.099ZM232.568 326.049C232.615 326.95 232.51 327.775 232.179 328.562C235.763 327.077 239.612 328.311 243.233 329.771C245.722 330.8 245.923 329.018 245.483 328.401C244.728 327.307 243.265 326.106 241.416 326.08C240.184 326.063 235.444 326.02 232.568 326.049H232.568ZM235.594 308.542C234.594 308.111 233.432 308.525 232.391 309.622C228.89 313.052 224.783 316.394 221.468 318.993C220.231 320.068 218.967 321.996 224.244 323.923C224.435 323.995 228.281 325.421 230.719 325.512C231.714 325.484 231.711 326.97 231.526 327.366C231.106 328.158 231.41 328.46 230.561 329.222C229.676 329.969 230.656 330.936 231.352 330.279C234.322 327.7 239.14 329.35 243.782 330.86C244.879 331.163 246.886 331.078 246.869 329.565C246.888 327.916 248.082 326.751 248.813 326.708C250.708 327.037 260.073 327.141 262.958 326.79C264.639 326.572 264.741 329.094 265.64 330.088C266.261 330.748 268.649 330.922 270.286 330.2C273.522 328.696 278.454 328.696 280.464 330.133C281.291 330.762 281.943 330.252 281.473 329.613C280.868 328.739 280.882 328.334 280.581 327.644C279.826 326.109 280.429 325.733 281.22 325.622C290.162 324.469 293.016 321.418 290.282 318.93C286.752 315.834 282.821 312.721 279.435 309.063C278.517 308.092 277.911 307.703 276 308.497C270.158 311.158 262.743 313.097 255.486 313.24C248.734 313.298 239.45 310.174 235.595 308.542L235.594 308.542Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.534 309.022C277.065 309.068 276.566 309.214 276.195 309.35C268.978 311.885 262.348 313.66 255.44 313.648C248.697 313.635 241.634 311.78 235.292 309.173C234.931 309.019 234.516 309.043 234.104 309.148C233.692 309.253 233.285 309.444 233.017 309.704C230.071 312.638 226.883 315.487 223.461 318.072C222.944 318.467 223.029 319.472 223.866 319.816H223.891C230.609 322.227 237.168 326.718 255.946 326.541C274.902 326.362 281.627 321.978 287.647 319.968C288.072 319.806 288.509 319.564 288.709 319.184C288.81 318.995 288.837 318.759 288.76 318.527C288.683 318.295 288.53 318.079 288.254 317.845H288.229C284.812 315.052 281.152 312.824 278.749 309.427C278.479 309.039 278.005 308.975 277.535 309.022L277.534 309.022ZM277.56 309.376C277.97 309.335 278.283 309.397 278.444 309.628C280.905 313.108 284.61 315.351 288 318.122C288.243 318.328 288.357 318.511 288.404 318.653C288.452 318.796 288.44 318.892 288.379 319.007C288.258 319.237 287.902 319.468 287.52 319.614C281.425 321.649 274.845 326.008 255.945 326.187C237.246 326.363 230.791 321.897 224.016 319.462C223.406 319.211 223.461 318.523 223.688 318.35C227.119 315.756 230.343 312.896 233.294 309.957C233.497 309.76 233.822 309.593 234.179 309.502C234.536 309.411 234.917 309.396 235.165 309.502C241.539 312.122 248.604 314.014 255.414 314.027C262.385 314.04 269.088 312.245 276.321 309.704C276.681 309.572 277.149 309.416 277.559 309.376H277.56Z",
    fill: "#BD6B00"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.497 186.886C231.441 185.77 233.17 185.685 232.972 187.219C232.719 189.13 236.579 193.967 236.899 196.95C237.113 198.95 235.724 200.701 234.347 201.791C232.66 203.098 230.065 202.918 228.852 202.168C228.117 201.577 227.447 199.553 227.997 198.751C228.192 198.482 229.071 201.723 231.008 201.71C233.643 201.693 235.778 199.713 235.856 197.948C235.991 194.872 231.545 190.012 231.497 186.885L231.497 186.886Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.206 194.482C239.642 194.17 240.338 195.53 239.847 195.87C239.438 196.142 238.64 194.859 239.206 194.482Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.379 191.723C240.159 191.83 239.721 191.678 239.851 191.491C240.468 190.61 241.782 189.284 242.735 188.821C243.028 188.679 243.54 189.196 243.363 189.449C242.793 190.264 241.405 191.225 240.379 191.723L240.379 191.723Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.564 183.641C250.808 183.131 252.276 182.554 252.65 182.209C252.996 181.855 253.161 182.509 253.014 182.817C252.769 183.327 251.502 184.189 250.946 184.212C250.648 184.224 250.416 183.95 250.564 183.641V183.641Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.05 183.803C254.368 182.907 255.394 181.549 256.099 181.102C256.462 180.873 257.112 181.054 256.99 181.397C256.72 182.157 255.466 183.485 254.622 184.111C254.366 184.339 253.977 184.011 254.05 183.803L254.05 183.803Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.065 186.044C250.853 186.151 250.968 186.604 251.173 186.672C251.608 186.817 252.402 186.845 252.761 186.647C253.283 186.326 253.045 184.346 252.347 185.404C251.878 186.056 251.536 185.846 251.065 186.044V186.044Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.168 190.59C244.102 189.76 245.455 188.597 246.569 189.409C248.74 191.046 243.331 197.319 240.388 200.252C239.85 200.826 239.377 199.379 240.067 198.757C242.177 196.967 244.152 194.829 245.526 192.62C245.79 192.195 246.043 191.278 245.168 190.59L245.168 190.59Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.521 185.195C257.653 184.401 256.235 185.212 256.209 184.158C256.196 183.601 257.759 183.21 258.412 183.851C259.515 184.971 258.69 186.859 256.855 186.978C255.325 187.046 252.773 189.15 253.161 189.593C253.603 190.139 257.57 190.5 259.877 190.138C261.305 189.938 261.006 191.215 259.543 191.388C258.129 191.551 256.977 191.4 255.656 191.815C254.101 192.26 253.422 194.347 252.558 195.126C252.366 195.261 251.847 194.442 252.044 194.133C252.667 193.16 253.659 191.67 254.751 191.244C255.44 190.965 252.851 190.877 252.025 190.641C251.37 190.443 251.56 189.611 251.811 189.146C252.145 188.422 254.585 185.978 255.569 186.018C256.493 186.057 257.429 185.788 257.521 185.195L257.521 185.195Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.63 185.405C262.089 185 262.324 184.322 262.805 183.91C263.069 183.646 263.491 183.962 263.42 184.6C263.361 185.102 262.687 185.535 262.233 185.913C261.864 186.189 261.435 185.592 261.63 185.405H261.63Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.864 183.544C267.547 183.469 267.717 184.788 266.971 185.001C266.517 185.152 266.121 183.622 266.864 183.544Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.141 187.621C265.131 188.757 265.691 188.652 266.761 188.614C267.799 188.574 268.712 188.64 268.708 187.615C268.703 186.552 268.12 185.622 267.949 186.345C267.798 187.025 267.678 188.137 267.283 187.653C266.91 187.236 267.058 187.145 266.416 187.828C266.06 188.205 266.02 187.646 265.806 187.294C265.657 187.086 265.142 187.463 265.141 187.621L265.141 187.621Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.683 193.413C257.427 194.916 257.661 197.02 258.431 197.044C259.381 197.075 261.349 193.758 262.281 192.038C262.839 191.078 263.799 190.91 263.399 191.912C262.793 193.457 262.847 196.764 263.38 197.735C263.666 198.259 265.777 197.256 266.118 196.51C266.739 195.155 266.234 192.658 266.452 191.133C266.557 190.132 267.473 189.923 267.425 190.851C267.334 192.511 267.177 195.555 267.293 196.937C267.363 197.732 269.635 198.905 270 196.498C270.193 194.984 270.973 193.49 269.963 191.812C269.336 190.762 270.882 190.894 271.715 192.327C272.298 193.303 271.224 194.917 271.262 196.165C271.358 198.085 269.865 199.175 268.782 199.198C267.813 199.218 267.182 198.028 266.389 198.012C265.509 197.955 264.604 199.381 263.876 199.331C261.056 199.138 262.55 195.016 261.69 194.966C260.735 194.909 259.608 199.005 258.431 198.859C257.27 198.72 256.069 195.521 256.552 194.167C256.989 192.908 257.812 192.613 257.683 193.413L257.683 193.413Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.338 186.918C269.962 186.079 271.425 183.896 272.097 184.663C273.396 186.218 274.706 189.91 275.621 190.215C276.201 190.409 276.174 187.486 276.582 186.158C276.846 185.176 278.033 185.497 277.806 186.754C277.729 187.174 276.256 191.949 276.369 192.137C277.389 194.178 278.399 196.248 279.038 198.438C279.302 199.381 278.168 198.746 278.033 198.55C277.309 197.468 276.042 193.33 276.042 193.519C275.46 196.43 275.322 197.289 274.704 199.762C274.515 200.555 273.349 200.411 273.612 199.015C273.865 197.867 275.533 192.225 275.439 192.062C274.128 189.747 272.929 187.916 271.338 186.918V186.918Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.821 200.346C273.438 200.303 272.842 201.2 274.753 201.552C277.306 202.014 280.101 201.154 280.957 198.651C281.938 195.668 282.586 192.845 283.099 191.78C283.738 190.538 284.557 190.639 283.953 188.827C283.527 187.522 282.731 187.916 282.564 188.613C282.118 190.514 280.424 196.664 279.895 197.796C278.898 199.863 276.888 200.681 273.821 200.346L273.821 200.346Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.934 190.534C278.66 189.947 278.023 190.401 278.137 191.043C278.204 191.623 278.675 191.938 279.147 191.922C279.707 191.902 280.891 191.941 280.894 191.011C280.895 190.359 280.383 189.813 280.002 190.534C279.637 191.186 279.169 191.118 278.934 190.534H278.934Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.573 188.075C279.377 188.211 279.553 188.937 279.787 188.929C280.621 188.901 281.802 188.635 282.435 188.195C282.621 188.066 282.544 187.627 282.28 187.636C281.476 187.663 280.196 187.642 279.573 188.075L279.573 188.075Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.659 189.903C287.263 188.959 288.93 188.863 288.33 190.21C287.906 191.138 283.758 199.153 283.192 200.172C282.574 201.318 282.069 200.751 282.508 199.858C283.098 198.71 286.47 190.182 286.659 189.903V189.903Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.414 201.835C280.237 201.197 279.248 200.254 279.359 201.96C279.556 205.057 283.811 204.078 285.099 202.977C286.269 201.941 285.254 206.474 286.808 206.959C287.664 207.233 289.276 206.065 290.069 205.037C292.266 202.185 293.665 198.097 295.778 195.282C296.576 194.181 295.341 193.396 294.842 194.272C293.004 197.354 290.721 203.643 288.228 205.277C286.195 206.577 286.798 203.602 286.727 202.708C286.638 202.052 285.839 201.087 284.773 201.973C284.028 202.555 282.87 203.029 281.821 202.934C281.214 202.9 280.7 202.911 280.414 201.835L280.414 201.835Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.01 196.083C288.033 195.909 287.111 195.829 287.156 196.724C287.188 197.387 287.98 197.566 288.117 197.472C289.363 196.565 287.852 197.017 288.011 196.083L288.01 196.083Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.198 199.715C285.953 199.773 285.728 200.557 286.306 200.601C286.834 200.639 288.905 200.416 289.477 200.45C289.848 200.436 289.989 199.728 289.195 199.766C288.233 199.814 286.968 199.573 286.198 199.715L286.198 199.715Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.075 186.238C236.404 186.254 237.305 187.421 237.246 187.786C237.205 187.958 236.282 187.76 236 187.521C235.791 187.345 235.875 186.228 236.075 186.238V186.238ZM231.732 194.693C230.909 195.142 231.863 196.029 232.479 195.654C234.794 194.155 238.267 192.581 238.993 189.613C239.226 188.607 240.16 187.066 241.047 186.722C241.905 186.39 243.149 188.273 243.962 186.791C244.439 185.944 246.109 187.347 246.511 186.441C247.002 185.346 246.769 184.743 246.789 183.695C246.753 183.008 246.228 182.802 245.848 183.915C245.649 184.418 245.882 184.927 245.721 185.189C245.598 185.389 245.215 185.583 244.993 185.416C244.788 185.262 244.93 184.833 244.439 184.644C244.249 184.548 243.944 184.469 243.811 184.713C243.229 185.752 242.906 186.721 242.09 185.617C241.363 184.665 240.995 183.021 240.463 185.271C240.271 186.066 239.064 187.218 238.352 187.218C237.463 187.218 237.686 184.877 235.733 185.234C234.729 185.448 234.799 187.369 234.948 188.079C235.195 189.066 238.129 188.357 237.983 189.002C237.481 191.244 234.369 193.375 231.732 194.693L231.732 194.693Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.368 205.378C213.243 205.753 213.742 206.772 214.259 206.847C214.766 206.885 215.025 205.747 214.862 205.378C214.741 205.107 213.457 205.112 213.368 205.378H213.368Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.062 209.326C215.736 208.975 214.776 209.917 215.552 210.582C215.988 210.935 217.585 211.447 218.022 210.702C218.613 209.743 217.439 206.263 217.959 205.802C218.365 205.443 220.246 208.128 221.175 208.321C223.357 208.623 222.833 204.585 225.184 204.859C226.787 205.073 226.963 203.07 226.739 201.82C226.561 200.62 224.618 198.889 223.725 198.114C222.55 197.136 222.026 198.835 222.764 199.395C223.713 200.155 225.382 201.691 225.647 202.706C225.773 203.185 224.488 204.138 224.014 203.88C222.921 203.284 221.905 200.727 220.949 200.143C220.623 199.944 219.822 200.393 220.208 201.191C220.641 202.046 222.558 203.37 222.67 204.282C222.771 205.114 221.816 206.914 221.188 206.914C220.498 206.914 218.74 204.739 218.191 203.716C217.916 203.226 216.965 203.273 216.866 203.95C216.708 204.966 217.013 207.115 217.255 208.447C217.448 209.708 216.545 209.771 216.062 209.326L216.062 209.326Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.769 202.393C212.495 202.704 213.41 203.311 213.592 203.153C213.944 202.848 215.314 201.287 215.05 200.741C214.815 200.254 212.932 199.189 212.625 199.716C212.057 200.629 214.4 201.038 214.033 201.306C213.853 201.41 213.208 201.855 212.769 202.393Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.143 195.55C216.143 195.55 216.731 197.563 217.21 196.724C217.598 196.143 216.143 195.55 216.143 195.55Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.105 198.753C216.89 198.871 216.283 199.351 216.678 199.607C217.303 199.977 219.004 200.27 218.637 199.06C218.414 198.348 221.202 199.08 220.522 197.151C220.345 196.617 219.504 195.847 219.09 195.738C218.827 195.669 217.934 196.159 218.493 196.428C218.901 196.64 220.131 197.362 219.674 197.836C219.155 198.331 218.794 197.614 218.148 197.729C217.823 197.791 218.035 198.715 217.852 198.966C217.75 199.107 217.281 198.657 217.105 198.753L217.105 198.753Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.538 191.1C221.187 191.276 220.556 192.23 220.533 192.671C220.521 192.906 220.779 193.23 220.98 193.129C221.349 192.945 221.919 192.042 221.94 191.628C221.954 191.366 221.757 190.991 221.538 191.1L221.538 191.1Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.836 190.85C223.156 190.019 224.557 188.786 225.187 190.448C225.568 191.491 229.626 196.833 230.457 198.645C231.044 199.871 230.435 200.378 229.709 199.499C227.653 196.876 225.967 193.607 223.836 190.85L223.836 190.85Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.002 190.963C228.726 190.179 230.203 188.577 229.805 187.684C229.5 186.916 228.602 186.992 228.448 187.169C227.57 188.218 229.073 187.955 228.856 188.313C228.409 189.153 227.963 189.615 227.732 190.423C227.678 190.612 227.871 191.104 228.002 190.963L228.002 190.963Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.923 193.584C290.403 193.163 291.434 191.122 292.132 191.923C294.047 194.139 294.937 201.336 295.491 206.722C295.491 206.722 294.63 207.44 294.623 207.326C294.623 204.457 293.47 195.679 290.923 193.584V193.584Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.967 186.578C247.348 185.154 248.897 184.627 249.129 185.642C250.205 190.32 252.783 193.862 254.744 197.043C255.335 198.037 254.861 198.63 253.425 197.715C252.431 197.033 251.421 194.547 250.932 194.449C250.047 194.284 247.928 198.487 243.595 197.288C242.474 196.974 242.548 193.641 242.527 192.168C242.48 191.478 243.242 191.296 243.268 192.237C243.308 193.595 243.267 196.415 245.003 196.51C246.419 196.589 249.555 194.587 250.216 193.023C250.804 191.414 248.637 188.216 247.967 186.578L247.967 186.578Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.088 206.155C292.434 205.191 297.034 197.47 297.638 195.772C297.947 194.953 299.267 197.177 297.978 198.377C296.845 199.396 293.503 204.876 292.88 206.796C292.593 207.663 291.722 207.25 292.087 206.155L292.088 206.155Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.91 198.794C300.76 195.61 302.817 199.285 301.005 201.097C298.207 203.837 297.365 209.068 292.926 209.855C291.73 210.112 289.624 209.317 288.999 208.873C288.756 208.7 289.157 207.564 289.905 208.119C290.986 208.963 293.22 209.154 294.399 208.194C296.921 205.718 298.975 202.439 299.91 198.793V198.794Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.791 209.1C253.591 209.33 252.98 209.292 252.925 209.615C252.684 210.812 252.925 211.419 252.661 212.572C252.408 213.676 251.642 213.717 251.694 212.818C251.764 211.651 252.725 210.004 252.046 209.891C251.594 209.785 251.245 209.18 251.713 208.881C252.596 208.269 253.07 208.363 253.677 208.547C253.889 208.612 253.943 208.923 253.791 209.1L253.791 209.1Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.169 207.538C251.997 208.562 250.911 208.981 249.833 210.276C249.393 210.806 249.405 211.546 249.142 212.222C248.879 212.94 248.03 213.081 247.767 212.932C247.328 212.643 247.391 211.311 246.9 212.028C246.484 212.688 246.215 213.597 245.6 213.586C245.043 213.574 243.992 212.436 244.525 212.381C246.347 212.194 246.324 210.736 247.007 210.64C247.772 210.538 247.822 211.844 248.295 211.583C248.666 211.392 248.841 209.87 249.244 209.459C250.479 208.197 251.456 207.53 252.716 206.603C253.354 206.094 253.809 207.011 253.168 207.538L253.169 207.538Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.44 211.462C256.502 211.651 256.662 212.857 256.937 213.006C257.392 213.218 258.094 213.307 258.357 211.921C258.48 211.352 258.591 214.751 259.839 213.441C260.557 212.648 262.336 213.585 263.081 212.587C263.614 211.922 263.779 211.458 263.363 210.476C263.242 210.178 262.512 210.325 262.553 211.049C262.59 211.66 262.12 212.414 261.509 212.285C261.213 212.231 261.677 210.791 261.379 210.401C261.215 210.186 260.965 210.21 260.802 210.432C260.573 210.743 261.032 212.123 260.279 212.305C259.329 212.524 259.827 211.382 259.425 211.173C258.132 210.521 258.007 211.342 257.44 211.462H257.44Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.761 209.148C265.448 208.954 265.233 208.953 266.315 208.068C266.736 207.749 266.819 208.683 266.775 209.052C266.697 209.679 265.952 209.237 265.721 209.788C265.382 210.505 265.52 212.173 265.407 212.853C265.329 213.202 264.77 213.172 264.717 212.896C264.556 212.068 264.83 211.257 264.804 210.221C264.795 209.87 264.291 209.318 264.761 209.148L264.761 209.148Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.716 207.028C260.55 207.778 260.562 208.395 260.562 208.909C260.6 209.325 261.36 209.057 261.357 209.004C261.319 208.346 261.469 207.435 261.275 207.182C261.169 207.045 260.755 206.887 260.716 207.028V207.028Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.628 199.529L254.448 204.054L252.807 201.021V204.13L249.267 199.934L250.499 204.434L247.318 201.729L249.011 204.788L243.369 201.147L246.959 205.344L242.445 203.119L245.677 205.849L238.291 203.068L245.421 206.582C248.027 205.298 251.601 204.509 255.576 204.509C259.537 204.509 263.128 205.306 265.732 206.582C265.741 206.587 265.774 206.578 265.783 206.582L272.862 203.068L265.578 205.875L268.758 203.119L264.296 205.319L267.835 201.147L262.193 204.788L263.885 201.729L260.705 204.434L261.936 199.934L258.397 204.156L258.448 201.021L256.807 204.055L255.627 199.53L255.628 199.529Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M249.383 297.77C249.383 298.249 249.31 298.942 249.166 299.847H248.831C248.831 299.23 248.802 298.756 248.744 298.424C248.69 298.092 248.582 297.698 248.42 297.24C248.286 296.854 248.14 296.525 247.982 296.255C247.823 295.981 247.569 295.617 247.219 295.162L247.89 293.507C248.2 293.904 248.42 294.208 248.55 294.421C248.697 294.666 248.836 294.975 248.966 295.346C249.1 295.718 249.202 296.107 249.274 296.515C249.347 296.922 249.383 297.34 249.383 297.77",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M254.641 294.566C254.641 295.071 254.545 295.45 254.354 295.702C254.163 295.955 253.837 296.135 253.375 296.243C253.508 296.712 253.597 297.078 253.64 297.342C253.687 297.605 253.71 297.899 253.71 298.223C253.71 298.432 253.698 298.656 253.672 298.894C253.651 299.132 253.609 299.453 253.548 299.857H253.245C253.245 299.496 253.225 299.186 253.186 298.927C253.149 298.663 253.094 298.416 253.018 298.185C253 298.128 252.904 297.873 252.731 297.423C252.562 296.968 252.392 296.591 252.223 296.292C252.057 295.989 251.784 295.573 251.406 295.042L251.925 293.484C252.199 293.877 252.439 294.15 252.645 294.301C252.85 294.449 253.094 294.523 253.375 294.523C253.988 294.523 254.295 294.191 254.295 293.528H254.608C254.608 293.744 254.614 293.924 254.625 294.069C254.635 294.209 254.641 294.375 254.641 294.566",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M259.47 298.222L259.081 299.845C258.836 299.777 258.635 299.584 258.48 299.266C258.351 299.003 258.257 298.669 258.199 298.265C258.145 297.861 258.118 297.443 258.118 297.01C257.79 297.097 257.53 297.14 257.339 297.14C256.96 297.14 256.646 297.041 256.398 296.843C256.152 296.641 256.03 296.386 256.03 296.08C256.03 295.42 256.199 294.827 256.538 294.3C256.881 293.77 257.267 293.505 257.696 293.505C258.028 293.505 258.259 293.599 258.388 293.786C258.533 293.992 258.621 294.226 258.653 294.489C258.686 294.753 258.702 295.261 258.702 296.015C258.702 296.689 258.756 297.165 258.864 297.443C258.951 297.66 259.153 297.919 259.47 298.222V298.222ZM258.01 295.528C257.945 295.117 257.728 294.911 257.361 294.911C257.202 294.911 257.056 294.955 256.922 295.041C256.789 295.128 256.722 295.203 256.722 295.268C256.722 295.485 256.982 295.593 257.501 295.593C257.667 295.593 257.837 295.571 258.01 295.528",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M264.583 297.818L264.388 299.787C264.002 299.517 263.645 299.028 263.317 298.321C262.974 297.582 262.628 296.534 262.278 295.178C261.979 296.484 261.732 297.441 261.537 298.051C261.346 298.657 261.157 299.086 260.969 299.338C260.843 299.508 260.641 299.679 260.363 299.852L260.407 297.97C260.764 297.483 261.014 297.111 261.159 296.855C261.371 296.476 261.546 296.035 261.683 295.53C261.824 295.021 261.95 294.341 262.062 293.49H262.419C262.639 294.345 262.852 295.025 263.057 295.53C263.249 296.006 263.472 296.426 263.728 296.79C263.909 297.046 264.193 297.389 264.583 297.818",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M279.444 316.392C279.706 316.7 279.891 317.002 279.998 317.299C280.101 317.592 280.176 318.01 280.222 318.555L279.635 318.602C279.385 318.113 279.142 317.73 278.906 317.453C278.726 317.242 278.435 316.942 278.033 316.552C277.631 316.163 277.22 315.783 276.8 315.414C276.378 315.041 275.839 314.61 275.185 314.121C274.956 313.95 274.81 313.828 274.748 313.756C274.656 313.648 274.584 313.437 274.531 313.121C274.475 312.802 274.44 312.405 274.425 311.931L276.474 313.597C277.247 314.233 277.886 314.795 278.393 315.283C278.783 315.658 279.133 316.028 279.443 316.392L279.444 316.392ZM272.178 312.013L272.055 313.52L269.642 313.454L269.824 311.917L272.178 312.013V312.013ZM278.523 318.757L272.776 320.508L271.718 319.046L276.687 317.532C276.462 317.221 276.287 317.003 276.163 316.879C275.972 316.688 275.752 316.538 275.505 316.43C275.489 316.706 275.375 316.948 275.162 317.157C274.95 317.366 274.675 317.522 274.338 317.625C273.897 317.759 273.455 317.778 273.014 317.681C272.573 317.583 272.249 317.391 272.041 317.105C271.735 316.682 271.571 316.12 271.549 315.418C271.524 314.648 271.734 314.194 272.182 314.058C272.761 313.882 273.545 314.043 274.533 314.542C275.521 315.041 276.28 315.656 276.809 316.387L278.524 318.757H278.523ZM274.109 315.688C273.838 315.565 273.621 315.489 273.459 315.46C273.299 315.425 273.153 315.428 273.02 315.469C272.855 315.519 272.741 315.613 272.678 315.75C272.616 315.887 272.631 316.02 272.724 316.149C272.784 316.231 272.884 316.286 273.025 316.313C273.169 316.335 273.321 316.321 273.481 316.273C273.608 316.234 273.718 316.172 273.811 316.087C273.908 315.996 274.007 315.863 274.109 315.688L274.109 315.688ZM267.951 314.511L267.599 316.002L265.209 315.783L265.572 314.276L267.951 314.511L267.951 314.511ZM273.618 320.333L272.341 320.626C271.887 320.73 271.455 320.762 271.044 320.722C270.634 320.682 270.251 320.554 269.894 320.337C269.682 320.722 269.311 321.044 268.78 321.304C268.428 321.477 268.019 321.617 267.553 321.724L266.648 321.932L265.818 320.41L266.724 320.202C267.201 320.092 267.527 320.001 267.7 319.928C267.877 319.849 268.099 319.716 268.366 319.529C268.074 319.349 267.838 319.224 267.658 319.156C267.44 319.076 267.247 319.055 267.081 319.094C267.017 319.108 266.965 319.137 266.924 319.18C266.886 319.218 266.855 319.284 266.828 319.378L266.43 319.432C266.062 318.756 265.978 318.234 266.178 317.865C266.382 317.491 266.872 317.215 267.648 317.036C268.448 316.853 269.131 316.812 269.697 316.913C270.267 317.009 270.648 317.234 270.841 317.589C270.945 317.779 270.984 317.976 270.959 318.179C270.932 318.378 270.833 318.665 270.662 319.04C270.781 319.093 270.921 319.124 271.081 319.133C271.241 319.142 271.385 319.133 271.511 319.104L272.788 318.811L273.618 320.333H273.618ZM267.515 321.753L266.27 321.948C265.576 322.057 265.007 321.95 264.561 321.63C264.065 321.276 263.637 320.616 263.277 319.651L262.665 318.006C262.526 317.633 262.337 317.355 262.1 317.172C261.986 317.084 261.754 316.968 261.405 316.823L261.828 315.23C262.287 315.484 262.64 315.75 262.888 316.029C263.179 316.354 263.425 316.787 263.627 317.33L264.051 318.467C264.35 319.271 264.641 319.815 264.923 320.101C265.147 320.331 265.401 320.423 265.685 320.378L266.93 320.183L267.515 321.753L267.515 321.753ZM262.194 316.037L261.39 317.453L259.115 316.928L259.926 315.5L262.194 316.037L262.194 316.037ZM263.518 322.445L257.845 322.959L257.501 321.36L262.267 320.928C262.143 320.668 261.974 320.453 261.759 320.285C261.647 320.191 261.397 320.034 261.011 319.813L261.435 318.348C261.96 318.64 262.343 318.961 262.585 319.311C262.832 319.66 263.033 320.194 263.187 320.911L263.518 322.445H263.518ZM258.963 323.172C258.281 323.149 257.717 323.098 257.271 323.02C256.825 322.942 256.389 322.826 255.961 322.673C255.595 322.824 255.27 322.92 254.985 322.962C254.707 323.004 254.291 323.016 253.737 322.998L252.247 322.948C251.839 322.935 251.522 322.855 251.295 322.708C251.068 322.562 250.873 322.326 250.71 321.999C250.348 322.32 249.955 322.545 249.53 322.674C249.167 322.784 248.738 322.832 248.245 322.815L246.938 322.772L247.066 321.159L248.372 321.202C249.012 321.224 249.554 321.125 249.999 320.906C250.577 320.62 250.891 320.167 250.94 319.546L251.539 319.625C251.516 319.751 251.493 319.895 251.468 320.057C251.443 320.219 251.423 320.398 251.407 320.596C251.391 320.798 251.484 320.969 251.687 321.111C251.89 321.252 252.128 321.327 252.402 321.336L253.526 321.374C254.269 321.399 254.805 321.349 255.132 321.225C255.528 321.076 255.744 320.78 255.779 320.337C255.787 320.242 255.839 320.159 255.936 320.087C255.995 320.045 256.113 319.984 256.29 319.902L256.651 319.736C256.658 319.811 256.659 319.915 256.655 320.045C256.65 320.172 256.647 320.255 256.644 320.295C256.627 320.512 256.555 320.799 256.429 321.155C256.649 321.234 256.897 321.304 257.173 321.364C257.449 321.425 257.742 321.474 258.05 321.512C258.061 321.378 257.999 321.202 257.863 320.983C257.728 320.765 257.663 320.618 257.669 320.543C257.677 320.44 257.705 320.362 257.752 320.308C257.765 320.288 257.837 320.229 257.967 320.13L258.798 319.474C258.942 319.729 259.04 319.96 259.091 320.168C259.148 320.372 259.165 320.626 259.141 320.93L258.964 323.172L258.963 323.172ZM250.352 316.545L248.919 317.56L247.839 316.893L246.775 317.686L245.354 316.828L246.711 315.863L247.858 316.504L248.966 315.694L250.352 316.545H250.352ZM248.099 322.722L242.546 321.812L243.155 320.246L247.822 321.011C247.858 320.739 247.826 320.499 247.724 320.291C247.674 320.176 247.535 319.97 247.305 319.671L248.548 318.417C248.865 318.816 249.033 319.207 249.054 319.59C249.081 319.974 248.957 320.517 248.684 321.22L248.099 322.722L248.099 322.722ZM243.425 321.997L242.224 321.708C241.554 321.547 241.173 321.253 241.079 320.825C240.972 320.352 241.185 319.649 241.717 318.718L242.624 317.131C242.829 316.772 242.912 316.473 242.872 316.235C242.853 316.121 242.761 315.94 242.596 315.694L244.318 314.525C244.48 314.902 244.544 315.251 244.51 315.572C244.472 315.947 244.303 316.396 244.004 316.919L243.377 318.016C242.934 318.791 242.707 319.349 242.695 319.688C242.683 319.959 242.814 320.128 243.089 320.194L244.29 320.483L243.425 321.997L243.425 321.997ZM240.58 315.987L238.631 316.809L237.292 315.505L239.258 314.675L240.58 315.987V315.987ZM239.751 321.022C239.346 321.501 238.948 321.86 238.557 322.1C238.169 322.336 237.734 322.484 237.253 322.543C236.777 322.603 236.174 322.576 235.444 322.46C234.716 322.35 234.015 322.174 233.342 321.934C232.042 321.471 231.171 320.96 230.726 320.399C230.285 319.844 230.303 319.284 230.782 318.719C231.19 318.237 231.675 317.836 232.238 317.517C232.856 317.164 233.822 316.763 235.135 316.315L235.431 316.705C234.405 317.102 233.698 317.403 233.309 317.608C232.925 317.814 232.615 318.058 232.377 318.339C232.068 318.703 232.115 319.108 232.517 319.554C232.927 319.998 233.622 320.395 234.6 320.744C235.562 321.087 236.474 321.256 237.334 321.251C238.194 321.246 238.771 321.07 239.065 320.723C239.247 320.508 239.369 320.274 239.43 320.02C239.497 319.769 239.538 319.343 239.552 318.743L241.447 317.589C241.448 318.163 241.421 318.549 241.365 318.746C241.27 319.105 241.026 319.516 240.632 319.981L239.751 321.022",
    fill: "#BF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAf);
export default __webpack_public_path__ + "static/media/AF.0341456cd901b1fe20a5a044fc53c55c.svg";
export { ForwardRef as ReactComponent };